/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = 
  `<div class="swym-wishlist-grid">
		{{#products}} 
	<div class="swym-wishlist-griditem">
		<div class="swym-wishlist-productimg-titlewrap">
			<div class="swym-wishlist-productimg">
				<a href="{{du}}"aria-label="{{dt}}" class="swym-isimg-anchor swym-wishlist-image-wrapper">
					<img alt="" class="swym-wishlist-image" src="{{iu}}">
				</a>
			</div>
			<div class="swym-wishlist-producttxtcontent">
				<a href="{{du}}"aria-label="{{dt}}" class="swym-title swym-istitle-anchor swym-wishlist-title-wrapper medium_body">
					{{dt}}
				</a>
				<div class="swym-product-qtyprice-wrap">
					<div class="swym-product-qtywrap">
					<quantity-input class="quantity" data-url="{{du}}" data-section="template--{{empi}}__main">
						<button class="quantity__button no-js-hidden disabled" name="minus" type="button">
							<svg width="18" height="2" class="icon icon-minus" viewBox="0 0 18 2" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M1 1L17 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
							</svg>
						</button>
						<input class="quantity__input" type="number" name="quantity" 
						id="Quantity-template--{{empi}}__main" data-cart-quantity="" data-min="1" min="1" step="1" value="1" form="product-form-template--{{empi}}__main">
						<button class="quantity__button no-js-hidden" name="plus" type="button">
							<svg width="18" height="18" class="icon icon-plus" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M9 1V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
								<path d="M1 9L17 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
							</svg>
						</button>
					</qunatity-input>
					</div>
					<div class="swym-product-price swym-text swym-text-1">
						<div class="swym-product-final-price swym-value">
							{{cu}}{{pr}}
						</div>
					</div>
				</div>
				<div class="swym-product-removecontent">
					<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
						<span class="swym-icon">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0_999_11976" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
								<rect width="16" height="16" fill="#D9D9D9"/>
								</mask>
								<g mask="url(#mask0_999_11976)">
								<path d="M4.66406 14C4.2974 14 3.98351 13.8694 3.7224 13.6083C3.46128 13.3472 3.33073 13.0333 3.33073 12.6667V4H2.66406V2.66667H5.9974V2H9.9974V2.66667H13.3307V4H12.6641V12.6667C12.6641 13.0333 12.5335 13.3472 12.2724 13.6083C12.0113 13.8694 11.6974 14 11.3307 14H4.66406ZM11.3307 4H4.66406V12.6667H11.3307V4ZM5.9974 11.3333H7.33073V5.33333H5.9974V11.3333ZM8.66406 11.3333H9.9974V5.33333H8.66406V11.3333Z" fill="black" fill-opacity="0.8"/>
								</g>
							</svg>						
						</span>
						<span class="swym-remove-txt">Remove from Wishlist</span>
					</button>
				</div>
			</div>
		</div>
		<div class="swym-product-metafieldcontentwrap">
			<div class="swym-product-featurecontent"></div>
			<div class="swym-product-variantcontent swym-variant-title">
				<div class="swym-product-topvariant-content">
					{{variantinfo}}
				</div>
				<div class="swym-product-bottomvariant-content"></div>
			</div>
		</div>
		<div class="swym-product-actionbtnwrap">
				<input type="hidden" name="id" value="{{epi}}" class="product-variant-id">
				<input type="hidden" name="quantity" value="1" min="1" step="1">
				<input type="hidden"
					data-productid="{{empi}}"
					data-producttitle="{{dt}}"
					data-producthandle="{{handleinfo}}"
					data-productimg="{{iu}}"
					data-productprice="{{cu}}{{pr}}"
					data-productvarianttitle="{{variantinfo}}"
					data-producturl="{{du}}"
					value=""
					class="productcontent">
			<div class="swym-product-addtocart-btnwrap">
				<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-product-quantity="1" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 custom_btn black_btn">
					{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Buy Now{{/isInCart}}
				</button>
				<a href="{{du}}" class="swym-add-to-cart-btn custom_btn black_btn">View Product</a>
			</div>
			<div class="swym-product-quote-btnwrap">
				<a href="javascript:void(0);" class="swym-product-quote-btn custom_btn border_btn">Request a Quote</a>
			</div>
		</div> 
	</div>
       {{/products}}
	</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		$('.wishlist-content-loader .loading__spinner').addClass('hidden');
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			var purl = p.du;
			var productHandle = purl.split('/products/')[1];
			p.handleinfo = productHandle;
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}

		productQty();
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var productqty = e.currentTarget.getAttribute("data-product-quantity");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		qty:productqty,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Buy Now";
		e.target.setAttribute("data-state-cart", "swym-added");
		
		fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
			
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
			  $('.header__icon--cart').trigger('click');
            }
          }
		  
        })
        .catch((e) => {
          console.error(e);
        });
		
	}, function(e) {
		// console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function productQty(e) {
	$('.swym-product-qtywrap .quantity__button').click(function(){
		var current_product_qty = $(this).parent('.quantity').find('.quantity__input').val();
		$(this).parents('.swym-wishlist-griditem').find('.swym-product-actionbtnwrap .swym-add-to-cart-btn').attr('data-product-quantity',current_product_qty);
	});
}


if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */